import { render, staticRenderFns } from "./RootTabbar.vue?vue&type=template&id=bc38b38e&scoped=true&"
import script from "./RootTabbar.vue?vue&type=script&lang=js&"
export * from "./RootTabbar.vue?vue&type=script&lang=js&"
import style0 from "./RootTabbar.vue?vue&type=style&index=0&id=bc38b38e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc38b38e",
  null
  
)

export default component.exports